import { Component, OnInit, ViewChild } from '@angular/core';
import { PopoverController, NavParams, AlertController, MenuController, ModalController, IonContent } from '@ionic/angular';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { PtyLdService } from 'src/app/services/pty-ld.service';
import { PtyWsService } from 'src/app/services/pty-ws.service';
import {TranslationService} from "../../services/translation.service";

@Component({
    selector: 'app-seeker-useful-links',
    templateUrl: './seeker-useful-links.component.html',
    styleUrls: ['./seeker-useful-links.component.scss'],
})
export class SeekerUsefulLinksComponent implements OnInit {
    userTemplates: any = [];

    title: any = '';
    url: any = '';

    addFormShow: boolean = false;
    selectedItem: any;

    links: any;
    myLinks: any = [];
    adminLinks: any = [];
    currentLangID = 184;

    links_list: any = [
        { 'link': 'https://google.com', 'title': this._translationService.translate('Google') },
        { 'link': 'https://yahoo.com', 'title': this._translationService.translate('Yahoo') },
        { 'link': 'https://hotmail.com', 'title': this._translationService.translate('Hotmail') },
    ];

    @ViewChild(IonContent, { static: true }) content: IonContent;
    constructor(
        private navParams: NavParams,
        private alertCtrl: AlertController,
        private ld: PtyLdService,
        private ws: PtyWsService,
        public menuCtrl: MenuController,
        private modalCtrl: ModalController,
        private _translationService: TranslationService
    ) {
        this.userTemplates = this.navParams.get('templates');
    }

    ngOnInit() {
        this.loadLinks();
        this.getDefaultLang();
    }

    getDefaultLang() {
        const self = this;
        self.ws.invokeURL('get_default_language', {}).subscribe((res: any) => {
            if (res.error === 0) {
                this.currentLangID = res.result[0].language_id;
            }
            self.ld.showLoading(false);
        }, (err: any) => {
            self.ld.showLoading(false);
            self.ld.showToast(this._translationService.translate('UnknownError'));
        });
    }

    loadLinks() {
        let self = this;
        self.ld.showLoading(true).then(() => {
            self.ws.invokeURL('user_links', {}).subscribe((result: any) => {
                if (result.error === 0) {
                    this.links = result.links;
                    this.myLinks = this.links.filter(e => e.uploaded_by === 'O');
                    this.adminLinks = this.links.filter(e => e.uploaded_by === 'A' && e.language_id === this.currentLangID);
                }
                self.ld.showLoading(false);
            });
        });
    }

    async dismiss(option: any = '', obj: any = '', index: any = '') {
        await this.modalCtrl.dismiss({ option: option, object: obj });
    }

    cancelLink() {
        this.title = '';
        this.url = '';
        this.selectedItem = '';
        this.addFormShow = false;
    }

    editLink(event, link) {
        if (event) {
            event.stopPropagation();
        }
        this.selectedItem = link;
        this.title = link.title;
        this.url = link.url;
        this.addFormShow = true;
        this.scrollToTop();
    }

    scrollToTop() {
        this.content.scrollToTop(1500);
    }

    createTemplate() {
        this.addFormShow = true;
    }

    async confirmationAlert(event, obj: any) {
        if (event) {
            event.stopPropagation();
        }
        const alert = await this.alertCtrl.create({
            header: this._translationService.translate('ConfirmDelete'),
            message: this._translationService.translate('DeleteLinkQuery'),
            buttons: [
                {
                    text: this._translationService.translate('No'),
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: (blah) => {
                        console.error('Confirm Cancel: blah');
                    }
                }, {
                    text: this._translationService.translate('Yes'),
                    handler: () => {
                        this.save('delete', obj.title, obj.url, obj.uuid);
                    }
                }
            ]
        });

        await alert.present();
    }

    saveUrl() {
        if (this.title === '') {
            this.ld.showToast(this._translationService.translate('TitleMissing'));
            return;
        }

        var r = new RegExp('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?');
        var result = r.test(this.url);

        if (!result) {
            this.ld.showToast(this._translationService.translate('InvalidUrl'));
            return;
        }

        if (this.selectedItem) {
            this.save('update', this.title, this.url, this.selectedItem.uuid);
        } else {
            this.save('add', this.title, this.url);
        }
    }
    

    save(option: any, title: any, url: any, uuid: any = null) {
        let self = this;
        self.ld.showLoading(true).then(() => {
            self.ws.invokeURL('user_links_save', { option: option, title: title, url: url, uuid: uuid }).subscribe((result: any) => {
                if (result.error === 0) {
                    //reset fields
                    this.title = '';
                    this.url = '';

                    if (option === 'add') {
                        let newTmpl = { uuid: result.link, title: title, url: url };
                        self.links.unshift(newTmpl);
                        self.myLinks.unshift(newTmpl);
                        this.addFormShow = false;
                    } else if (option === 'delete' || option === 'update') {
                        let idx = self.links.map((el: any) => el.uuid).indexOf(uuid);
                        if (idx >= 0) {
                            if (option === 'delete') {
                                self.links.splice(idx, 1);
                                self.ld.showToast(this._translationService.translate('LinkDeleteSuccess'));
                            } else {
                                self.links[idx].edited = false;
                                self.links[idx].title = title;
                                self.links[idx].url = url;
                                this.selectedItem = '';
                                this.addFormShow = false;
                                self.ld.showToast(this._translationService.translate('LinkUpdateSuccess'));
                            }
                        }
                    }
                    self.ld.showLoading(false);
                } else {
                    self.ld.showLoading(false, { message: result.message });
                }
            }, (err: any) => {
                self.ld.showLoading(false, { message: this._translationService.translate('UnknownError') });
            });
        });
    }
}
